export default __webpack_public_path__ + "static/media/logo-ases.2b72c2af.png";